import { ArticulosGeneral } from '../class/articulos-general.interface';

export interface HistorialPedidos {
  situacion: string;
  documento: number;
  tipoformulario: number;
  gestion: number;
  clienteol: number;
  monto: number;
  nodo: number;
  iddocumento: number;
  estado: string;
  medios: MediosdePagoInterface[];
  items: BackUptArticulo[];
  itemsreales?: ArticulosGeneral[];
  myitemsdetalle?: ArticulosGeneral[];
  fecha: string;
  turnos: any[];
  modo: number;
  idPedido: number;
  factura?: any;
}
export interface BackUptArticulo {
  descripcion: string;
  marca: number;
  codigo: number;
  cantidad: number;
  bultos?: number;
  precio: number;
  monto: number;
  reemplazo: number;
  fraccion: number;
  observacion?: string;
}

export interface ArticuloPeticionEnviar{
  marca: number;
  codigo: number;
  cantidad: number;
  bultos: number;
  precio: number;
  monto: number;
  reemplazo: number;
  nombre?: string;
  observacion?: string;
}
export interface MediosdePagoInterface {
  mediopago: number;
  nombre: string;
  fiid: string;
}
